import { createApp } from 'vue';
import { createPinia } from 'pinia';
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
import Splide from '@splidejs/splide';
import { AutoScroll } from '@splidejs/splide-extension-auto-scroll';
import '@splidejs/splide/css';

import Basket from './components/Basket.vue';
import BasketLink from './components/BasketLink.vue';
import BasketProductAdd from './components/BasketProductAdd.vue';
import BasketQuickAdd from './components/BasketQuickAdd.vue';
import BasketByCategory from './components/BasketByCategory.vue';
import Modal from './components/Modal.vue';
import Products from './components/Products.vue';

const pinia = createPinia();
pinia.use(piniaPluginPersistedstate);


// const modalElements = document.querySelectorAll('.modal-component');
// if (modalElements) {
//     modalElements.forEach((element) => {
//         const modalApp = createApp(Modal, {
//             modalId: element.dataset.modalId,
//             title: element.dataset.title,
//             body: element.dataset.body,
//         });
//         modalApp.mount(element);
//     });
// }

// const basketElement = document.getElementById('basket');
// if (basketElement) {
//     const admin = basketElement.dataset.admin === 'true';
//     const basket = createApp(Basket, { admin });
//     basket.use(pinia);
//     basket.mount(basketElement);
// }

const productsListingElement = document.getElementById('products-listing');
if (productsListingElement) {
    const productsData = JSON.parse(productsListingElement.dataset.products || '[]');
    const categoriesData = JSON.parse(productsListingElement.dataset.categories || '[]');
    const products = createApp(Products, { products: productsData, categories: categoriesData });
    products.use(pinia);
    products.mount(productsListingElement);
}

const basketElement = document.getElementById('basket');
if (basketElement) {
    const admin = basketElement.dataset.admin === 'true';
    const basket = createApp(BasketByCategory, { admin });
    basket.use(pinia);
    basket.mount(basketElement);
}

const basketLinkElement = document.getElementById('basketLink');
if (basketLinkElement) {
    const basketLink = createApp(BasketLink);
    basketLink.use(pinia);
    basketLink.mount(basketLinkElement);
}

const basketProductAddElement = document.getElementById('basket-product-add');
if (basketProductAddElement) {
    const purchasables = JSON.parse(basketProductAddElement.dataset.purchasables || '[]');
    const basketProductAdd = createApp(BasketProductAdd, { purchasables });
    basketProductAdd.use(pinia);
    basketProductAdd.mount(basketProductAddElement);
}

// const basketQuickAddElements = document.querySelectorAll('.basket-quick-add');
// if (basketQuickAddElements) {
//     basketQuickAddElements.forEach((element) => {
//         const purchasables = JSON.parse(element.dataset.purchasables || '[]');
//         const basketQuickAdd = createApp(BasketQuickAdd, { purchasables, productUrl: element.dataset.productUrl });
//         basketQuickAdd.use(pinia);
//         basketQuickAdd.mount(element);
//     });
// }

const testimonials = document.querySelectorAll('.testimonials__content');
testimonials.forEach((testimonial) => {
    document.addEventListener('DOMContentLoaded', function() {
        var splide = new Splide(testimonial, {
            pagination: false,
            type: 'loop',
            autoHeight: true,
        });
        splide.mount();
    });
});

const marquees = document.querySelectorAll('.scrolling-marquee-splide');
document.addEventListener('DOMContentLoaded', function() {
    marquees.forEach((marquee) => {
        var splide = new Splide(marquee, {
            type: 'loop',
            drag: 'free',
            focus: 'center',
            pauseOnHover: false,
            pauseOnFocus: false,
            perPage: 5,
            autoWidth: true,
            gap: '5rem',
            arrows: false,
            pagination: false,
            autoScroll: {
                speed: 2,
            },
        });
        splide.mount({ AutoScroll });
    });
});
